import React from "react"
import { Controller, useFormContext } from "react-hook-form"
import TextArea from "../TextArea"

export const DETAILS_MAX_LENGTH = 600;

const MessageInput = () => {
    const { control, formState: { errors } } = useFormContext()
    return (
        <Controller
            name="Message"
            control={control}
            render={({ field }) => (
                <TextArea
                    id="Message"
                    name="Message"
                    title="Conte pra gente o que aconteceu (opcional)"
                    value={field.value}
                    maxLength={DETAILS_MAX_LENGTH}
                    onChange={(e) => field.onChange(e.target.value)}
                    tip={`${DETAILS_MAX_LENGTH - (field?.value?.length ?? 0)
                        } caracteres restantes`}
                    hasError={field.value?.length > DETAILS_MAX_LENGTH}
                    errorMessage={errors?.Message?.message}
                    {...field}
                />
            )}
        />
    )
}

export default MessageInput